<script lang="ts">
	import Advertising from './Advertising.svelte';
</script>

<Advertising adId="traffic" adFormat="300x250" showAdByDefault />
